import React from 'react';
import { Plus } from 'lucide-react';
import { Category } from '../../store/dashboardSlice';
import WidgetCard from '../WidgetCard/WidgetCard';
import AddWidgetCard from '../AddWidgetCard/AddWidgetCard';
import './CategorySection.css';

interface CategorySectionProps {
  category: Category;
  searchTerm: string;
  onAddWidget: () => void;
}

const CategorySection: React.FC<CategorySectionProps> = ({
  category,
  searchTerm,
  onAddWidget
}) => {
  // Filter widgets based on search term
  const filteredWidgets = category.widgets.filter(widget =>
    widget.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    widget.text.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className="category-section">
      <div className="category-header">
        <h2 className="category-title">{category.name}</h2>
        <button
          onClick={onAddWidget}
          className="add-widget-button"
        >
          <Plus size={16} />
          Add Widget
        </button>
      </div>

      <div className="widgets-grid">
        {searchTerm ? (
          // Show filtered results when searching
          filteredWidgets.length > 0 ? (
            filteredWidgets.map((widget) => (
              <WidgetCard key={widget.id} widget={widget} />
            ))
          ) : (
            <div className="no-results">
              <p>No widgets found matching "{searchTerm}"</p>
            </div>
          )
        ) : (
          // Normal display when not searching
          <>
            {category.widgets.map((widget) => (
              <WidgetCard key={widget.id} widget={widget} />
            ))}
            {category.widgets.length < 3 && (
              <AddWidgetCard onAddWidget={onAddWidget} />
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default CategorySection;
